export const MEDIA_QUERY_WIDTH = '800px'
export const OVERLAY_WIDTH = '600px'
export const SIDEBAR_WIDTH = '260px'
export const RECOIL_PERSIST_KEY = 'recoil-persist'
export const AFTER_LOGIN_ACTION_KEY = 'after-login-action-key'